(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yld-site-header"]) return;
  try {
    
  function initializeYldStorefront(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const toggle = root.querySelector('[data-yld-menu-toggle]');
    const nav = root.querySelector('#yld-navigation');
    const search = root.querySelector('[data-yld-search-placeholder]');
    function labelSearch() {
      search.querySelectorAll('input[type="search"]').forEach(input => {
        if (input.placeholder !== search.dataset.yldSearchPlaceholder) input.placeholder = search.dataset.yldSearchPlaceholder;
        if (input.getAttribute('aria-label') !== search.dataset.yldSearchLabel) input.setAttribute('aria-label', search.dataset.yldSearchLabel);
        if (input.hasAttribute('aria-labelledby')) input.removeAttribute('aria-labelledby');
      });
    }
    labelSearch();
    new MutationObserver(labelSearch).observe(search, { childList: true, subtree: true, attributes: true, attributeFilter: ['placeholder', 'aria-labelledby'] });
    function closeMenu() {
      nav.classList.remove('yld-mobile-open');
      toggle.setAttribute('aria-expanded', 'false');
      nav.querySelectorAll('details[open]').forEach(item => item.removeAttribute('open'));
    }
    toggle.addEventListener('click', () => {
      const open = !nav.classList.contains('yld-mobile-open');
      nav.classList.toggle('yld-mobile-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });
    nav.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const openSummary = nav.querySelector('details[open] > summary');
      const mobileOpen = nav.classList.contains('yld-mobile-open');
      closeMenu();
      if (mobileOpen) toggle.focus();
      else if (openSummary) openSummary.focus();
    });
    document.addEventListener('pointerdown', event => {
      if (!nav.contains(event.target) && !toggle.contains(event.target)) {
        nav.querySelectorAll('details[open]').forEach(item => item.removeAttribute('open'));
      }
    });
    nav.querySelectorAll('details').forEach(item => item.addEventListener('toggle', () => {
      if (item.open) nav.querySelectorAll('details').forEach(other => { if (other !== item) other.removeAttribute('open'); });
    }));
  }
  document.querySelectorAll('[data-yld-header]').forEach(initializeYldStorefront);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-yld-header]').forEach(initializeYldStorefront));

  } catch(e) { console.error(e); }
})();
})();
